import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import { Calendar } from "react-date-range";

const SingleDatePickerNew = ({ handleChange, toggleDatepicker }) => {
    const [selection, setSelection] = useState(undefined);
    const [show, setShow] = useState(false);
    const handleSelect = (item) => {
        setSelection(item);
        setShow(true);
    };

    const handleApply = () => {
        handleChange(selection);
        toggleDatepicker();
    };

    return (
        <>
            <Box
                sx={{
                    ".rdrMonthName": {
                        color: "white",
                    },
                    ".rdrMonthsVertical": {
                        backgroundColor: "#303030",
                    },
                    ".rdrDayNumber span": {
                        color: "white",
                    },
                    ".rdrDayToday": {
                        color: "#5ac36b",
                    },
                    ".rdrMonth": {
                        backgroundColor: "#303030",
                    },
                    ".rdrStaticRange": {
                        borderBottom: "1px solid #101010",
                        padding: 0,
                        background: "#fff",
                        "&:hover, &:focus": {
                            ".rdrStaticRangeLabel": {
                                background: "#505050",
                            },
                        },
                    },
                    ".rdrStaticRangeLabel": {
                        backgroundColor: "#303030",
                    },
                    ".rdrDayStartPreview": {
                        color: "#5ac36b!important",
                    },
                    ".rdrDayEndPreview": {
                        color: "#5ac36b!important",
                    },
                    ".rdrDayHovered": {
                        color: "#5ac36b!important",
                    },
                    ".rdrDayActive": {
                        color: "#5ac36b!important",
                    },
                    ".rdrDefinedRangesWrapper": {
                        fontSize: "12px",
                        width: "226px",
                        borderRight: "solid 1px #101010",
                        background: "#303030",
                        ".rdrStaticRangeSelected": {
                            color: "green",
                            fontWeight: 600,
                        },
                    },
                    ".rdrDateRangePickerWrapper": {
                        maxWidth: "100vw",
                    },
                    ".rdrDayDisabled": {
                        backgroundColor: "#303030",
                    },
                    ".rdrDayDisabled .rdrDayNumber span": {
                        color: "#666767",
                    },
                    ".rdrDayToday .rdrDayNumber span:after": {
                        content: '""',
                        position: "absolute",
                        bottom: "4px",
                        left: "50%",
                        transform: "translate(-50%, 0)",
                        width: "18px",
                        height: "2px",
                        borderRadius: "2px",
                        background: "#4CAF50 !important",
                    },
                    ".rdrMonthAndYearWrapper": {
                        backgroundColor: "#303030",
                    },
                    ".rdrMonthAndYearPickers": {
                        backgroundColor: "#303030",
                        color: "white",
                        height: "49px",
                    },
                    select: {
                        margin: "40px",
                        backgroundColor: "#373737!important",
                        color: "#fff!important",
                    },
                    "select option": {
                        background: "#303030",
                        color: "white",
                    },
                    "select option:hover": {
                        background: "#505050",
                    },
                    ".rdrDateDisplayWrapper": {
                        backgroundColor: "#303030",
                    },
                    ".rdrInputRange": {
                        display: "none",
                    },
                    ".rdrDateDisplayItem": {
                        borderRadius: "4px",
                        backgroundColor: "#373737",
                        border: "1px solid transparent",
                        input: {
                            cursor: "pointer",
                            height: "2.5em",
                            lineHeight: "2.5em",
                            border: 0,
                            background: "transparent",
                            width: "100%",
                            color: "#849095",
                        },
                    },
                }}
            >
                <Calendar minDate={new Date()} onChange={(item) => handleSelect(item)} />
            </Box>
            {show && <Button onClick={handleApply}> Apply</Button>}
        </>
    );
};

export default SingleDatePickerNew;
